import React, { FunctionComponent, useCallback, useState } from 'react'
import { Heading, Paragraph, majorScale, Checkbox, Pane } from 'evergreen-ui'
import DialogLayout from './DialogLayout'
import RecoveryCode from './RecoveryCode'

interface RecoveryCodeStepProps {
  onClickNext: () => void
  recoveryCode: string
}

const RecoveryCodeStep: FunctionComponent<RecoveryCodeStepProps> = props => {
  const { onClickNext, recoveryCode } = props

  const [isCheckboxClicked, setIsCheckboxClicked] = useState(false)

  const handleCheckboxClick = useCallback(() => {
    setIsCheckboxClicked(!isCheckboxClicked)
  }, [isCheckboxClicked])

  const handleRecoveryCodeSave = useCallback(() => {
    setIsCheckboxClicked(true)
  }, [])

  return (
    <DialogLayout onConfirmClick={onClickNext} confirmLabel="Done" confirmDisabled={!isCheckboxClicked}>
      <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
        Write down your recovery code
      </Heading>

      <Paragraph>
        In the event that you need to log in without your device you can use the recovery code below. Write this
        recovery code down somewhere safe.
      </Paragraph>

      <Pane marginY={majorScale(3)}>
        <RecoveryCode recoveryCode={recoveryCode} onSave={handleRecoveryCodeSave} />
      </Pane>

      <Checkbox
        onChange={handleCheckboxClick}
        checked={isCheckboxClicked}
        label="I have written down this security code."
        marginBottom="0"
      />
    </DialogLayout>
  )
}

export default RecoveryCodeStep
